import React, { useState, useContext, useEffect, useMemo, useRef } from 'react';

import { BrowserRouter, Routes, Route } from "react-router-dom";



import axios from 'axios';
import API_BASE_URL from "./config/api";
import TrackOrder from "./pages/TrackOrder";
import BottomNav from './components/BottomNav';
import FeedbackBubble from './components/FeedbackBubble';
import ProfileSettings from './pages/Profile/ProfileSettings';
import Notifications from './pages/Notifications/Notifications';
import OrderDetails from './pages/OrderDetails';

import { CartContext } from './pages/CartPage/CartContext';
import { UserOrdersProvider } from './context/UserOrdersContext';
import { NotificationProvider, useNotifications } from './context/NotificationContext';
import { publish, subscribe } from './utils/eventBus';



// Auth
import Login from './auth/LoginForm';

import Register from './auth/RegisterForm';
import ResetPassword from './auth/ResetPassword';
import VerifyOtp from "./auth/VerifyOtp";
import Home from "./pages/homepage/Home"; //k



/* ================= ICONS (UNCHANGED) ================= */
export const ShoppingCartIcon = ({ className }) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>;
export const HomeIcon = ({ className }) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>;
export const PackageIcon = ({ className }) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="m7.5 4.27 9 5.15"></path><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path><path d="m3.3 7 8.7 5 8.7-5"></path><path d="M12 22V12"></path></svg>;
export const XIcon = ({ className }) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>;
export const PlusIcon = ({ className }) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M12 5v14"></path><path d="M5 12h14"></path></svg>;
export const MinusIcon = ({ className }) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M5 12h14"></path></svg>;
export const MenuIcon = ({ className }) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="4" y1="12" x2="20" y2="12"></line><line x1="4" y1="6" x2="20" y2="6"></line><line x1="4" y1="18" x2="20" y2="18"></line></svg>;
export const SearchIcon = ({ className }) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>;

export const NotificationIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M15 17h5l-1.405-1.405A2.032 2.032 0 0 1 18.6 14.2V11a6 6 0 1 0-12 0v3.2c0 .538-.214 1.055-.595 1.435L4 17h5"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
);


const normalizeProduct = (product) => {
  if (!product) return product;
  return {
    ...product,
    id: product._id || product.id,
    image: product.image || product.imageUrl || product.image_url || "",
    price: Number(product.price || 0),
    category: product.category || product.categoryId || "General",
    rating: product.rating ?? null,
    reviews: product.reviews ?? null,
    multiDayDiscountDays: Number(product.multiDayDiscountDays || 0),
    multiDayDiscountPercent: Number(product.multiDayDiscountPercent || 0),
  };
};

const computePricingSummary = (cartItems = []) => {
  const groupedByCategory = (cartItems || []).reduce((acc, item) => {
    const key = item.categoryId || item.category || 'General';
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});

  const categoryDays = {};
  const categorySubtotals = {};
  const discountBreakdown = [];

  let subtotal = 0;
  let discountTotal = 0;

  Object.keys(groupedByCategory).forEach((categoryId) => {
    const items = groupedByCategory[categoryId] || [];
    const hasCheckin = items.some((i) => !!i.checkinDT);
    let selectedDays = 1;
    if (hasCheckin) {
      const ref = items.find((i) => !!i.checkinDT) || {};
      const dateDels = Array.isArray(ref.dateDels)
        ? ref.dateDels
        : (ref.dateDel ? [ref.dateDel] : []);
      selectedDays = Math.max(1, dateDels.length);
    }
    categoryDays[categoryId] = selectedDays;

    const catSubtotal = items.reduce((sum, i) => {
      const lineBase = Number(i.price || 0) * Number(i.quantity || 0);
      const line = hasCheckin ? (lineBase * selectedDays) : lineBase;
      return sum + line;
    }, 0);

    categorySubtotals[categoryId] = catSubtotal;
    subtotal += catSubtotal;

    const refForDiscount = items.find(
      (i) => Number(i.multiDayDiscountDays || 0) > 0 && Number(i.multiDayDiscountPercent || 0) > 0
    );
    if (!refForDiscount) return;

    const daysRequired = Number(refForDiscount.multiDayDiscountDays || 0);
    const percent = Number(refForDiscount.multiDayDiscountPercent || 0);
    if (daysRequired <= 0 || percent <= 0) return;
    if (selectedDays < daysRequired) return;

    const amount = (catSubtotal * percent) / 100;
    if (amount <= 0) return;

    discountTotal += amount;
    discountBreakdown.push({
      categoryId,
      percent,
      daysRequired,
      selectedDays,
      amount,
    });
  });

  const subtotalRounded = Math.round(subtotal * 100) / 100;
  const discountRounded = Math.round(discountTotal * 100) / 100;
  const totalRounded = Math.max(0, Math.round((subtotalRounded - discountRounded) * 100) / 100);

  return {
    subtotal: subtotalRounded,
    discountTotal: discountRounded,
    total: totalRounded,
    saved: discountRounded,
    categoryDays,
    categorySubtotals,
    discountBreakdown,
  };
};


// MessageModal Component - Replaces browser alert() for displaying messages.
const MessageModal = ({ message, type, onClose }) => {
  if (!message) return null;

  const bgColor = type === 'success' ? 'bg-green-100' : 'bg-red-100';
  const textColor = type === 'success' ? 'text-green-800' : 'text-red-800';
  const borderColor = type === 'success' ? 'border-green-400' : 'border-red-400';

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-[100]">
      <div className={`relative p-6 rounded-lg shadow-xl max-w-sm w-full ${bgColor} ${textColor} border ${borderColor}`}>
        <button onClick={onClose} className="absolute top-2 right-2 text-gray-500 hover:text-gray-700">
          <XIcon className="w-5 h-5" />
        </button>
        <p className="text-center font-medium">{message}</p>
      </div>
    </div>
  );
};



// Header Component - Contains the navigation, search bar, and mobile menu.
  const Header = ({ navigate, cartItemCount, searchQuery, setSearchQuery, isLoggedIn, userEmail, handleLogout, notificationCount, userName, currentPage, products = [], foodMode, setFoodMode }) => {
  // State to control the visibility of the mobile navigation menu.
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [isHeroVisible, setIsHeroVisible] = useState(true);
  const topRowRef = useRef(null);
  const [topRowHeight, setTopRowHeight] = useState(0);
  const mobileSearchBarRef = useRef(null);
  const [mobileSearchBarHeight, setMobileSearchBarHeight] = useState(0);
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const desktopSearchRef = useRef(null);
  const mobileSearchRef = useRef(null);

  const closeSearchFocus = () => {
    setIsSearchFocused(false);
    desktopSearchRef.current?.blur?.();
    mobileSearchRef.current?.blur?.();
  };

  // Helper to check if a product belongs to food category (3amigos)
  const isFoodProduct = (p) => {
    const cat = ((p.category || p.categoryId || '').toString() + ' ' + (p.categoryName || '')).toLowerCase().replace(/\s+/g, '').replace(/[^a-z0-9]/g, '');
    return cat.includes('3amigos') || cat === 'food' || cat === 'foods' || cat === 'fooditems' || cat.includes('threeamigos');
  };

  // Filter products based on search query AND active toggle tab
  const filteredProducts = searchQuery.trim()
    ? products
        .filter(p => foodMode ? isFoodProduct(p) : !isFoodProduct(p))
        .filter(p =>
          (p.name || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
          (p.description || '').toLowerCase().includes(searchQuery.toLowerCase())
        ).slice(0, 8)
    : [];

  // Toggles the mobile menu's open/close state.
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    if (currentPage !== 'products') {
      setIsHeroVisible(true);
      return;
    }

    const hero = document.getElementById('home-hero');
    if (!hero) {
      setIsHeroVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        setIsHeroVisible(!!entry?.isIntersecting);
      },
      { threshold: 0.1 }
    );

    observer.observe(hero);
    return () => observer.disconnect();
  }, [currentPage]);

  const shouldStick = currentPage !== 'products' || isHeroVisible;

  useEffect(() => {
    const element = topRowRef.current;
    if (!element) return;

    const measure = () => {
      const rect = element.getBoundingClientRect();
      setTopRowHeight(Math.ceil(rect.height));
    };

    measure();

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(element);
      return () => resizeObserver.disconnect();
    }

    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);

  useEffect(() => {
    const element = mobileSearchBarRef.current;
    if (!element) return;

    const measure = () => {
      const rect = element.getBoundingClientRect();
      setMobileSearchBarHeight(Math.ceil(rect.height));
    };

    measure();

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(element);
      return () => resizeObserver.disconnect();
    }

    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [currentPage]);

  return (
    <header className="text-white">
      {isSearchFocused && !isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/40 backdrop-blur-[1px] z-[40]"
          aria-hidden="true"
          onMouseDown={(e) => {
            e.preventDefault();
            closeSearchFocus();
          }}
          onTouchStart={(e) => {
            e.preventDefault();
            closeSearchFocus();
          }}
        />
      )}

      <div
        ref={topRowRef}
        className={`${shouldStick ? 'fixed top-0 left-0 right-0 z-50' : ''} bg-gradient-to-r from-blue-600 to-purple-700 shadow-lg px-4`}
      >
        <div className="container mx-auto flex justify-between items-center py-4">
          <h1 className="text-3xl font-extrabold tracking-tight cursor-pointer" onClick={() => navigate('products')}>
            techbegin<span className="text-base font-semibold ml-1 align-baseline">.in</span>
          </h1>

          {/* Search bar for desktop and tablet views. Hidden on smaller screens. Only show on products page. */}
          {currentPage === 'products' && (
          <div className={`hidden md:flex flex-grow max-w-md mx-4 relative ${isSearchFocused ? 'z-[60]' : ''}`}>
            <div className="flex items-center w-full gap-3">
            <div className="relative flex-1">
            <input
              ref={desktopSearchRef}
              type="text"
              placeholder="Search..."
              className={`w-full py-2 pl-10 pr-4 rounded-full border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-gray-300 transition-all ${isSearchFocused ? 'ring-4 ring-white/20 shadow-[0_0_0_8px_rgba(255,255,255,0.10)]' : ''}`}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onFocus={() => {
                setIsSearchFocused(true);
                setIsMobileMenuOpen(false);
              }}
              onBlur={() => setTimeout(() => setIsSearchFocused(false), 150)}
            />
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            
            {/* Desktop Search Results Dropdown */}
            {isSearchFocused && filteredProducts.length > 0 && (
              <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-2xl shadow-2xl overflow-hidden max-h-80 overflow-y-auto">
                {filteredProducts.map((product) => (
                  <button
                    key={product._id || product.id}
                    className="w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition text-left border-b border-gray-100 last:border-0"
                    onMouseDown={() => navigate('productDetail', product._id || product.id)}
                  >
                    <img
                      src={product.image || product.imageUrl || `https://placehold.co/60x60/E0F2F7/000?text=${(product.name || 'P')[0]}`}
                      alt={product.name}
                      className="w-12 h-12 rounded-lg object-cover bg-gray-100"
                    />
                    <div className="flex-1 min-w-0">
                      <div className="text-sm font-semibold text-gray-800 truncate">{product.name}</div>
                      <div className="text-xs text-gray-500">₹{product.price}</div>
                    </div>
                  </button>
                ))}
              </div>
            )}
            </div>

            {/* Food Toggle */}
            <div className="flex flex-col items-center gap-0.5 flex-shrink-0">
              <span className="text-xs font-semibold text-white/90 leading-none">food</span>
              <button
                onClick={() => setFoodMode(!foodMode)}
                className={`relative w-12 h-6 rounded-full transition-all duration-300 ease-in-out focus:outline-none ${
                  foodMode
                    ? 'bg-gradient-to-r from-green-400 to-green-500 shadow-[0_0_8px_rgba(74,222,128,0.4)]'
                    : 'bg-gray-300'
                }`}
                aria-label="Toggle food mode"
              >
                <span
                  className={`absolute top-0.5 w-5 h-5 bg-white rounded-full shadow-md transition-all duration-300 ease-in-out ${
                    foodMode ? 'left-[26px]' : 'left-0.5'
                  }`}
                />
              </button>
            </div>
            </div>
          </div>
          )}

          <nav className="flex items-center space-x-4">
          {/* Mobile navigation icons: Hamburger and Cart. Hidden on larger screens. */}
          <div className="md:hidden flex items-center space-x-4"> {/* Mobile icons: notifications, cart, menu */}
            <button
              onClick={() => { navigate('notifications'); setIsMobileMenuOpen(false); }}
              className="relative text-white focus:outline-none"
              aria-label="Notifications"
            >
              <NotificationIcon className="w-6 h-6" />
              {notificationCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                  {notificationCount}
                </span>
              )}
            </button>

            <button onClick={toggleMobileMenu} className="text-white focus:outline-none">
              <MenuIcon className="w-8 h-8" />
            </button>
          </div>

          {/* Desktop navigation links. Hidden on smaller screens. */}
          <div className="hidden md:flex items-center space-x-6">
            <button
              onClick={() => navigate('notifications')}
              className="relative text-white hover:text-blue-200 transition duration-300"
              aria-label="Notifications"
            >
              <NotificationIcon className="w-6 h-6" />
              {notificationCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                  {notificationCount}
                </span>
              )}
            </button>
            <button
              className="relative flex items-center space-x-2 text-lg font-medium hover:text-blue-200 transition duration-300 transform hover:scale-105"
              onClick={() => { navigate('cart'); setIsMobileMenuOpen(false); }}
              data-cart-icon
            >
              <ShoppingCartIcon className="w-6 h-6" />
              <span>Cart</span>
              {cartItemCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center animate-bounce">
                  {cartItemCount}
                </span>
              )}
            </button>
            <button
              className="text-lg font-medium hover:text-blue-200 transition duration-300"
              onClick={() => navigate("trackOrder")}
            >
              Track Order
            </button>

            


            
            {/* Conditional rendering for Login/Logout */}
            {isLoggedIn ? (
              <div className="relative">
                <button
                  className="flex items-center space-x-2 text-white hover:text-blue-200 transition duration-300"
                  onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}
                >
                  <div className="w-10 h-10 rounded-full bg-white text-blue-600 flex items-center justify-center font-bold">
                    {(userName || userEmail.split('@')[0]).charAt(0).toUpperCase()}
                  </div>
                </button>
                
                {isProfileDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-xl z-50 overflow-hidden">
                    <div className="px-4 py-3 bg-gradient-to-r from-blue-600 to-purple-700 text-white">
                      <p className="text-sm font-semibold">{userName || 'User'}</p>
                      <p className="text-xs opacity-90">{userEmail}</p>
                    </div>
                    
                    <div className="py-2">
                      <button
                        onClick={() => {
                          navigate('profile');
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full px-4 py-2 text-left text-gray-700 hover:bg-blue-50 transition flex items-center space-x-2"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                        </svg>
                        <span>Profile Settings</span>
                      </button>
                      
                      <button
                        onClick={() => {
                          navigate('notifications');
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full px-4 py-2 text-left text-gray-700 hover:bg-blue-50 transition flex items-center space-x-2"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
                        </svg>
                        <span>Notifications</span>
                        {notificationCount > 0 && (
                          <span className="ml-auto bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                            {notificationCount}
                          </span>
                        )}
                      </button>
                      
                      <hr className="my-2" />
                      
                      <button
                        onClick={() => {
                          handleLogout();
                          setIsProfileDropdownOpen(false);
                        }}
                        className="w-full px-4 py-2 text-left text-red-600 hover:bg-red-50 transition flex items-center space-x-2"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clipRule="evenodd" />
                        </svg>
                        <span>Logout</span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <>
                <button
                  className="text-lg font-medium hover:text-blue-200 transition duration-300 transform hover:scale-105"
                  onClick={() => { navigate('login'); setIsMobileMenuOpen(false); }}
                >
                  <span>Login</span>
                </button>
                <button
                  className="bg-white text-blue-600 font-bold py-2 px-4 rounded-full shadow-md hover:bg-blue-100 transition duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75"
                  onClick={() => { navigate('register'); setIsMobileMenuOpen(false); }}
                >
                  <span>Register</span>
                </button>
              </>
            )}
          </div>
        </nav>
      </div>
      </div>

      {shouldStick && topRowHeight > 0 && (
        <div aria-hidden="true" style={{ height: topRowHeight }} />
      )}

      {/* Mobile-only search bar: sticky at top. Only show on products page. */}
      {currentPage === 'products' && (
      <div ref={mobileSearchBarRef} className={`md:hidden ${shouldStick ? 'fixed z-40' : 'relative'} left-0 right-0 bg-gray-50`} style={shouldStick ? { top: topRowHeight } : {}}>
        <div className="container mx-auto px-4 py-3">
        <div className={`relative ${isSearchFocused ? 'z-[60]' : ''}`}>
          <div className="flex items-center gap-3">
          <div className="relative flex-1">
          <input
            ref={mobileSearchRef}
            type="text"
            placeholder="Search..."
            className={`w-full py-2.5 pl-10 pr-4 rounded-full border-2 border-gray-200 bg-white text-gray-800 focus:outline-none focus:border-gray-300 transition-all shadow-sm ${isSearchFocused ? 'ring-4 ring-white/20 shadow-[0_0_0_8px_rgba(255,255,255,0.10)]' : ''}`}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onFocus={() => {
              setIsSearchFocused(true);
              setIsMobileMenuOpen(false);
            }}
            onBlur={() => setTimeout(() => setIsSearchFocused(false), 150)}
          />
          <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          
          {/* Mobile Search Results Dropdown */}
          {isSearchFocused && filteredProducts.length > 0 && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-2xl shadow-2xl overflow-hidden max-h-72 overflow-y-auto">
              {filteredProducts.map((product) => (
                <button
                  key={product._id || product.id}
                  className="w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition text-left border-b border-gray-100 last:border-0"
                  onMouseDown={() => navigate('productDetail', product._id || product.id)}
                >
                  <img
                    src={product.image || product.imageUrl || `https://placehold.co/48x48/E0F2F7/000?text=${(product.name || 'P')[0]}`}
                    alt={product.name}
                    className="w-10 h-10 rounded-lg object-cover bg-gray-100"
                  />
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-semibold text-gray-800 truncate">{product.name}</div>
                    <div className="text-xs text-gray-500">₹{product.price}</div>
                  </div>
                </button>
              ))}
            </div>
          )}
          </div>

          {/* Food Toggle - Mobile */}
          <div className="flex flex-col items-center gap-0.5 flex-shrink-0">
            <span className="text-xs font-semibold text-gray-500 leading-none">food</span>
            <button
              onClick={() => setFoodMode(!foodMode)}
              className={`relative w-12 h-6 rounded-full transition-all duration-300 ease-in-out focus:outline-none ${
                foodMode
                  ? 'bg-gradient-to-r from-green-400 to-green-500 shadow-[0_0_8px_rgba(74,222,128,0.4)]'
                  : 'bg-gray-300'
              }`}
              aria-label="Toggle food mode"
            >
              <span
                className={`absolute top-0.5 w-5 h-5 bg-white rounded-full shadow-md transition-all duration-300 ease-in-out ${
                  foodMode ? 'left-[26px]' : 'left-0.5'
                }`}
              />
            </button>
          </div>
          </div>
        </div>
        </div>
      </div>
      )}

      {/* Spacer for sticky mobile search bar */}
      {currentPage === 'products' && shouldStick && mobileSearchBarHeight > 0 && (
        <div className="md:hidden" aria-hidden="true" style={{ height: mobileSearchBarHeight }} />
      )}

      {/* Mobile menu overlay. Appears when isMobileMenuOpen is true. */}
      {isMobileMenuOpen && (
        <div className="md:hidden fixed inset-0 z-[70]">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={toggleMobileMenu}
          />
          <div className="absolute bottom-0 left-0 right-0 bg-white rounded-t-3xl shadow-2xl p-6 space-y-5 animate-fade-in">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm text-gray-500">Welcome</div>
                <div className="text-lg font-semibold text-gray-900">{isLoggedIn ? (userName || userEmail.split('@')[0]) : 'Guest'}</div>
              </div>
              <button onClick={toggleMobileMenu} className="text-gray-500">
                <XIcon className="w-7 h-7" />
              </button>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <button
                className="flex items-center justify-center gap-2 border rounded-xl py-3 text-gray-700 hover:bg-gray-50"
                onClick={() => { navigate('products'); setIsMobileMenuOpen(false); }}
              >
                <HomeIcon className="w-5 h-5" />
                Home
              </button>
              <button
                className="flex items-center justify-center gap-2 border rounded-xl py-3 text-gray-700 hover:bg-gray-50"
                onClick={() => { navigate('cart'); setIsMobileMenuOpen(false); }}
              >
                <ShoppingCartIcon className="w-5 h-5" />
                Cart
              </button>
              <button
                className="flex items-center justify-center gap-2 border rounded-xl py-3 text-gray-700 hover:bg-gray-50"
                onClick={() => { navigate('trackOrder'); setIsMobileMenuOpen(false); }}
              >
                <PackageIcon className="w-5 h-5" />
                Track Order
              </button>
              <button
                className="flex items-center justify-center gap-2 border rounded-xl py-3 text-gray-700 hover:bg-gray-50"
                onClick={() => { navigate('notifications'); setIsMobileMenuOpen(false); }}
              >
                <NotificationIcon className="w-5 h-5" />
                Notifications
              </button>
            </div>

            <div className="space-y-2">
              {isLoggedIn ? (
                <>
                  <button
                    className="w-full text-left px-4 py-3 rounded-xl bg-gray-100 text-gray-700"
                    onClick={() => { navigate('profile'); setIsMobileMenuOpen(false); }}
                  >
                    Profile Settings
                  </button>
                  <button
                    className="w-full text-left px-4 py-3 rounded-xl bg-red-50 text-red-600"
                    onClick={() => { handleLogout(); setIsMobileMenuOpen(false); }}
                  >
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <button
                    className="w-full text-left px-4 py-3 rounded-xl bg-blue-600 text-white"
                    onClick={() => { navigate('login'); setIsMobileMenuOpen(false); }}
                  >
                    Login
                  </button>
                  <button
                    className="w-full text-left px-4 py-3 rounded-xl bg-purple-600 text-white"
                    onClick={() => { navigate('register'); setIsMobileMenuOpen(false); }}
                  >
                    Register
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

// Footer Component - Displays copyright and designer information.
const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white p-6 pb-20 md:pb-6 mt-8 shadow-inner">
      <div className="container mx-auto text-center text-sm">
        <p>&copy; {new Date().getFullYear()} techbegin.in. All rights reserved.</p>
        <p className="mt-2">Designed by Tarun kumar</p>
      </div>
    </footer>
  );
};






// Product Detail Component - Displays detailed information for a single product.
const ProductDetail = ({ navigate, productId, products }) => {
  const product = (products || []).find((p) => (p._id || p.id) === productId);
  const { addToCart } = useContext(CartContext);
  // State for the "Add to Cart" button animation in the detail view.
  const [animatedButtonId, setAnimatedButtonId] = useState(null);

  const calories = Number.isFinite(Number(product?.calories)) ? Number(product.calories) : null;
  const preparationTime = Number.isFinite(Number(product?.preparationTime)) ? Number(product.preparationTime) : null;
  const protein = Number.isFinite(Number(product?.protein)) ? Number(product.protein) : null;
  const hasMeta = calories != null || preparationTime != null || protein != null;

  // Handles adding the product to cart and triggers the animation.
  const handleAddToCartClick = (product) => {
    const productId = product._id || product.id;
    addToCart({
      ...product,
      id: productId,
      image: product.image || product.imageUrl || "",
      price: Number(product.price || 0)
    });
    setAnimatedButtonId(productId);
    setTimeout(() => {
      setAnimatedButtonId(null);
    }, 500);
  };

  // Renders a "Product not found" message if the product ID doesn't match.
  if (!product) {
    return (
      <div className="container mx-auto p-8 text-center text-red-600 text-xl">
        Product not found. <button onClick={() => navigate('products')} className="text-blue-600 underline">Go back to products</button>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4 md:p-8 pb-28 md:pb-8">
      <button
        onClick={() => navigate('products')}
        className="mb-6 flex items-center text-blue-600 hover:text-blue-800 transition duration-200 font-medium"
      >
        &larr; Back to Products
      </button>

      <div className="bg-white rounded-xl shadow-lg p-6 md:p-10 flex flex-col md:flex-row gap-8 items-center">
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={product.image || product.imageUrl || ""}
            alt={product.name}
            className="w-full max-w-md h-auto rounded-lg shadow-md object-cover"
            onError={(e) => { e.target.onerror = null; e.target.src = `https://placehold.co/600x600/E0F2F7/000000?text=${product.name.replace(/\s/g, '+')}`; }}
          />
        </div>
        <div className="w-full md:w-1/2">
          <h2 className="text-4xl font-extrabold text-gray-900 mb-3">{product.name}</h2>
          <p className="text-blue-700 text-3xl font-bold mb-4">₹{Number(product.price || 0).toFixed(2)}</p>

          {hasMeta && (
            <div className="flex flex-wrap gap-3 mb-4">
              {preparationTime != null && (
                <div className="px-3 py-2 rounded-lg bg-gray-100 text-gray-800 text-sm font-semibold">{preparationTime} min</div>
              )}
              {calories != null && (
                <div className="px-3 py-2 rounded-lg bg-gray-100 text-gray-800 text-sm font-semibold">{calories} cal</div>
              )}
              {protein != null && (
                <div className="px-3 py-2 rounded-lg bg-gray-100 text-gray-800 text-sm font-semibold">{protein}g protein</div>
              )}
            </div>
          )}

          <p className="text-gray-700 text-lg leading-relaxed mb-6">{product.description || ""}</p>

          <div className="mb-6">
            <span className="text-gray-600 font-semibold">Category: </span>
            <span className="text-gray-800">{product.category || product.categoryId || "General"}</span>
          </div>
          {product.rating != null && product.reviews != null && (
            <div className="mb-6">
              <span className="text-yellow-500 font-bold">{product.rating} / 5</span> ({product.reviews} reviews)
            </div>
          )}

          <button
            onClick={() => handleAddToCartClick(product)}
            // Dynamically applies the 'animate-pop' class when the button is clicked.
            className={`w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-full shadow-lg hover:shadow-xl transition duration-300 transform focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75 text-lg
              ${animatedButtonId === (product._id || product.id) ? 'animate-pop' : 'hover:scale-105'}`}
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

// Cart Component - Displays items in the shopping cart and allows quantity adjustments.
const Cart = ({ navigate }) => {
  const { cartItems, increaseQuantity, decreaseQuantity, removeFromCart, clearCart, updateCartItem } =
    useContext(CartContext);

  const [customDateInputByCategory, setCustomDateInputByCategory] = useState({});
  const [timePickerCategoryId, setTimePickerCategoryId] = useState(null);
  const [timePickerHour, setTimePickerHour] = useState('12');
  const [timePickerMinute, setTimePickerMinute] = useState('00');
  const [timePickerAmPm, setTimePickerAmPm] = useState('PM');

  const grouped = cartItems.reduce((acc, item) => {
    const key = item.categoryId || item.category || 'General';
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});

  const categories = Object.keys(grouped);

  const pricing = useMemo(() => computePricingSummary(cartItems || []), [cartItems]);

  const LEAD_TIME_MS = 12 * 60 * 60 * 1000;

  const formatDateInput = (dateObj) => {
    const y = dateObj.getFullYear();
    const m = String(dateObj.getMonth() + 1).padStart(2, '0');
    const d = String(dateObj.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  const formatDateDisplay = (yyyyMmDd) => {
    if (!yyyyMmDd || typeof yyyyMmDd !== 'string') return '';
    const [y, m, d] = yyyyMmDd.split('-');
    if (!y || !m || !d) return yyyyMmDd;
    return `${d}-${m}-${y}`;
  };

  const formatTimeDisplay12h = (time24) => {
    if (!time24) return '';
    const [hhRaw = '00', mm = '00'] = String(time24).split(':');
    const hh = Number(hhRaw);
    if (!Number.isFinite(hh)) return time24;
    const ampm = hh >= 12 ? 'PM' : 'AM';
    const hour12 = ((hh + 11) % 12) + 1;
    return `${String(hour12).padStart(2, '0')}:${String(mm).padStart(2, '0')} ${ampm}`;
  };

  const buildUpcoming7Dates = () => {
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    return Array.from({ length: 7 }, (_, idx) => {
      const dt = new Date(start);
      dt.setDate(start.getDate() + idx);
      return formatDateInput(dt);
    });
  };

  const getCategorySchedule = (categoryId) => {
    const item = (grouped[categoryId] || []).find((i) => !!i.checkinDT);
    return {
      scheduleMode: item?.scheduleMode || 'week',
      scheduleCountMode: item?.scheduleCountMode || 'single',
      dateDels: Array.isArray(item?.dateDels) ? item.dateDels : (item?.dateDel ? [item.dateDel] : []),
      timeDel: item?.timeDel || '',
    };
  };

  const updateCategorySchedule = (categoryId, updates) => {
    (grouped[categoryId] || [])
      .filter((i) => !!i.checkinDT)
      .forEach((i) => {
        const nextDateDels = updates.dateDels;
        updateCartItem(i.id, {
          ...updates,
          // Keep legacy single date field in sync for older code paths
          ...(Array.isArray(nextDateDels) ? { dateDel: nextDateDels[0] || '' } : {}),
        });
      });
  };

  const validateLeadTime = (dateDels, timeDel) => {
    const now = Date.now();
    if (!timeDel) return { ok: true };
    if (!Array.isArray(dateDels) || dateDels.length === 0) return { ok: true };

    const invalid = [];
    for (const dateStr of dateDels) {
      const dt = new Date(`${dateStr}T${timeDel}:00`);
      if (Number.isNaN(dt.getTime())) {
        invalid.push(dateStr);
        continue;
      }
      if (dt.getTime() < now + LEAD_TIME_MS) invalid.push(dateStr);
    }

    if (invalid.length === 0) return { ok: true };
    return { ok: false, invalidDates: invalid };
  };
  const finalTotalCart = pricing.total;

  return (
    <div className="container mx-auto p-4 md:p-8">
      <h2 className="text-4xl font-bold text-center text-gray-800 mb-8 mt-4">Your Shopping Cart</h2>

      {cartItems.length === 0 ? (
        <div className="text-center text-gray-600 text-xl py-10 bg-white rounded-xl shadow-lg">
          <p className="mb-4">Your cart is empty.</p>
          <button
            onClick={() => navigate('products')}
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-5 rounded-full shadow-md hover:shadow-lg transition duration-300"
          >
            Start Shopping
          </button>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8">
          <div className="space-y-10">
            {categories.map((categoryId) => (
              <div key={categoryId}>
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-2xl font-extrabold text-gray-900">{categoryId}</h3>
                  <span className="text-sm font-semibold text-gray-600">
                    {grouped[categoryId].reduce((n, it) => n + (it.quantity || 0), 0)} items
                  </span>
                </div>

                {grouped[categoryId].some((i) => !!i.checkinDT) && (() => {
                  const schedule = getCategorySchedule(categoryId);
                  const maxDates = schedule.scheduleCountMode === 'multiple' ? 5 : 1;
                  const weekDates = buildUpcoming7Dates();
                  const leadCheck = validateLeadTime(schedule.dateDels, schedule.timeDel);
                  const categoryCustomDate = customDateInputByCategory[categoryId] || '';

                  const toggleDate = (dateStr) => {
                    const current = Array.isArray(schedule.dateDels) ? schedule.dateDels : [];
                    const exists = current.includes(dateStr);
                    let next = exists ? current.filter((d) => d !== dateStr) : [...current, dateStr];
                    if (next.length > maxDates) {
                      // If single day: replace. If multiple: trim to max.
                      next = schedule.scheduleCountMode === 'single' ? [dateStr] : next.slice(0, maxDates);
                    }
                    updateCategorySchedule(categoryId, { dateDels: next });
                  };

                  const addCustomDate = () => {
                    if (!categoryCustomDate) return;
                    const current = Array.isArray(schedule.dateDels) ? schedule.dateDels : [];
                    if (current.includes(categoryCustomDate)) return;
                    let next = schedule.scheduleCountMode === 'single' ? [categoryCustomDate] : [...current, categoryCustomDate];
                    if (next.length > maxDates) next = next.slice(0, maxDates);
                    updateCategorySchedule(categoryId, { dateDels: next });
                    setCustomDateInputByCategory((prev) => ({ ...prev, [categoryId]: '' }));
                  };

                  const removeSelectedDate = (dateStr) => {
                    const current = Array.isArray(schedule.dateDels) ? schedule.dateDels : [];
                    updateCategorySchedule(categoryId, { dateDels: current.filter((d) => d !== dateStr) });
                  };

                  return (
                    <div className="mb-6 p-4 rounded-xl bg-blue-50 border border-blue-100">
                      <div className="flex flex-col gap-3">
                        <div className="flex flex-col md:flex-row md:items-end gap-3">
                          <div className="flex-1">
                            <label className="block text-sm font-semibold text-gray-700 mb-1">Delivery dates</label>
                            <select
                              className="w-full border rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-400"
                              value={schedule.scheduleCountMode}
                              onChange={(e) => {
                                const nextMode = e.target.value;
                                const nextMax = nextMode === 'multiple' ? 5 : 1;
                                const current = Array.isArray(schedule.dateDels) ? schedule.dateDels : [];
                                updateCategorySchedule(categoryId, {
                                  scheduleCountMode: nextMode,
                                  dateDels: current.slice(0, nextMax),
                                });
                              }}
                            >
                              <option value="single">One day</option>
                              <option value="multiple">Up to 5 alternative days</option>
                            </select>
                          </div>

                          <div className="flex-1">
                            <label className="block text-sm font-semibold text-gray-700 mb-1">Pick mode</label>
                            <select
                              className="w-full border rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-400"
                              value={schedule.scheduleMode}
                              onChange={(e) => {
                                const mode = e.target.value;
                                updateCategorySchedule(categoryId, { scheduleMode: mode });
                              }}
                            >
                              <option value="week">Pick from a week</option>
                              <option value="custom">Pick any date(s)</option>
                            </select>
                          </div>

                          <div className="flex-1">
                            <label className="block text-sm font-semibold text-gray-700 mb-1">Time</label>
                            <button
                              type="button"
                              className="w-full border rounded-lg px-3 py-2 text-gray-800 bg-white text-left focus:outline-none focus:ring-2 focus:ring-blue-400"
                              onClick={() => {
                                const [hhRaw = '12', mmRaw = '00'] = String(schedule.timeDel || '12:00').split(':');
                                const hh24 = Number(hhRaw);
                                const mm = String(mmRaw).padStart(2, '0');
                                const ampm = hh24 >= 12 ? 'PM' : 'AM';
                                const hour12 = ((hh24 + 11) % 12) + 1;
                                setTimePickerHour(String(hour12).padStart(2, '0'));
                                setTimePickerMinute(mm);
                                setTimePickerAmPm(ampm);
                                setTimePickerCategoryId(categoryId);
                              }}
                            >
                              {schedule.timeDel ? formatTimeDisplay12h(schedule.timeDel) : 'Select time'}
                            </button>
                          </div>
                        </div>

                        {schedule.scheduleMode === 'week' && (
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div>
                              <label className="block text-sm font-semibold text-gray-700 mb-1">Upcoming 7 days</label>
                              <p className="mt-1 text-xs text-gray-600">Pick from the next 7 days.</p>
                            </div>
                            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 content-start">
                              {weekDates.map((d) => (
                                <label key={d} className="flex items-center gap-2 text-sm text-gray-800 bg-white border rounded-lg px-2 py-2">
                                  <input
                                    type="checkbox"
                                    checked={(schedule.dateDels || []).includes(d)}
                                    onChange={() => toggleDate(d)}
                                  />
                                  <span>{formatDateDisplay(d)}</span>
                                </label>
                              ))}
                            </div>
                          </div>
                        )}

                        {schedule.scheduleMode === 'custom' && (
                          <div className="flex flex-col md:flex-row md:items-end gap-3">
                            <div className="flex-1">
                              <label className="block text-sm font-semibold text-gray-700 mb-1">Add date</label>
                              <input
                                type="date"
                                className="w-full border rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-400"
                                value={categoryCustomDate}
                                onChange={(e) => setCustomDateInputByCategory((prev) => ({ ...prev, [categoryId]: e.target.value }))}
                              />
                            </div>
                            <button
                              type="button"
                              onClick={addCustomDate}
                              className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg shadow transition duration-200"
                            >
                              Add
                            </button>
                          </div>
                        )}

                        {Array.isArray(schedule.dateDels) && schedule.dateDels.length > 0 && (
                          <div className="flex flex-wrap gap-2">
                            {schedule.dateDels.map((d) => (
                              <button
                                key={d}
                                type="button"
                                onClick={() => removeSelectedDate(d)}
                                className="text-sm bg-white border border-blue-200 text-blue-700 px-3 py-1 rounded-full hover:bg-blue-100"
                                title="Remove"
                              >
                                {formatDateDisplay(d)} ×
                              </button>
                            ))}
                          </div>
                        )}

                        {!leadCheck.ok && (
                          <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg p-3">
                            We can deliver only if you order at least 12 hours before the selected time.
                            Please choose a later date/time.
                          </div>
                        )}

                        <p className="text-xs text-gray-600">
                          This tab requires a delivery date/time selection (applies to all items in {categoryId}).
                        </p>
                      </div>
                    </div>
                  );
                })()}

                <div className="space-y-6">
                  {grouped[categoryId].map((item) => (
                    <div
                      key={item.id}
                      className="flex flex-col gap-3 border-b border-gray-200 pb-4 last:border-b-0 last:pb-0"
                    >
                      <div className="flex flex-col sm:flex-row items-center justify-between">
                        <div className="flex items-center flex-grow mb-4 sm:mb-0">
                          <img
                            src={item.image}
                            alt={item.name}
                            className="w-20 h-20 object-cover rounded-lg mr-4"
                            onError={(e) => { e.target.onerror = null; e.target.src = `https://placehold.co/80x80/E0F2F7/000000?text=${item.name.replace(/\s/g, '+')}`; }}
                          />
                          <div className="w-full">
                            <h4 className="text-lg font-semibold text-gray-900">{item.name}</h4>
                            <p className="text-gray-600">
                              ₹{Number(item.price || 0).toFixed(2)}
                              {grouped[categoryId].some((i) => !!i.checkinDT) ? (
                                <span className="text-gray-500"> / day</span>
                              ) : null}
                            </p>
                            {grouped[categoryId].some((i) => !!i.checkinDT) && (
                              <p className="text-xs text-gray-500 mt-1">
                                {pricing.categoryDays[categoryId] || 1} day(s) selected
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="flex items-center space-x-4">
                          <div className="flex items-center border border-gray-300 rounded-full px-2 py-1">
                            <button
                              onClick={() => decreaseQuantity(item.id)}
                              className="text-gray-700 hover:text-blue-600 transition duration-200 p-1 rounded-full hover:bg-gray-100"
                            >
                              <MinusIcon className="w-5 h-5" />
                            </button>
                            <span className="mx-2 text-lg font-medium">{item.quantity}</span>
                            <button
                              onClick={() => increaseQuantity(item.id)}
                              className="text-gray-700 hover:text-blue-600 transition duration-200 p-1 rounded-full hover:bg-gray-100"
                            >
                              <PlusIcon className="w-5 h-5" />
                            </button>
                          </div>
                          <span className="text-lg font-bold text-blue-700 w-24 text-right">
                            ₹{(
                              (Number(item.price || 0) * Number(item.quantity || 0)) *
                              (grouped[categoryId].some((i) => !!i.checkinDT) ? (pricing.categoryDays[categoryId] || 1) : 1)
                            ).toFixed(2)}
                          </span>
                          <button
                            onClick={() => removeFromCart(item.id)}
                            className="text-red-500 hover:text-red-700 transition duration-200 p-1 rounded-full hover:bg-red-50"
                          >
                            <XIcon className="w-6 h-6" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center">
            <div className="text-2xl font-bold text-gray-900 mb-4 md:mb-0">
              {Number(pricing.discountTotal || 0) > 0 ? (
                <div className="space-y-1">
                  <div className="text-sm text-gray-600">Subtotal: ₹{Number(pricing.subtotal || 0).toFixed(2)}</div>
                  <div className="text-sm text-green-700 font-semibold">Discount: -₹{Number(pricing.discountTotal || 0).toFixed(2)}</div>
                  <div className="text-sm text-green-700">You saved ₹{Number(pricing.saved || 0).toFixed(2)}</div>
                  <div>
                    Total: <span className="text-blue-700">₹{finalTotalCart.toFixed(2)}</span>
                  </div>
                </div>
              ) : (
                <>
                  Total: <span className="text-blue-700">₹{Number(pricing.subtotal || 0).toFixed(2)}</span>
                </>
              )}
            </div>
            <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4 w-full md:w-auto">
              <button
                onClick={clearCart}
                className="bg-red-500 hover:bg-red-600 text-white font-bold py-3 px-6 rounded-full shadow-md hover:shadow-lg transition duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-75 w-full sm:w-auto"
              >
                Clear Cart
              </button>
              <button
                onClick={() => navigate('checkout')}
                className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-full shadow-md hover:shadow-lg transition duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-75 w-full sm:w-auto"
              >
                Proceed to Checkout
              </button>
            </div>
          </div>
          {/* mobile-only spacer so the fixed BottomNav doesn't overlap the action buttons */}
          <div className="h-24 md:hidden" />
        </div>
      )}

      {/* Time picker modal (MI-style wheel-ish) */}
      {timePickerCategoryId && (
        <div className="fixed inset-0 bg-black/50 flex items-end md:items-center justify-center z-[120]">
          <div className="w-full md:max-w-md bg-white rounded-t-2xl md:rounded-2xl p-4 shadow-2xl">
            <div className="flex items-center justify-between mb-3">
              <h4 className="text-lg font-bold text-gray-900">Select time</h4>
              <button
                type="button"
                className="text-gray-500 hover:text-gray-700"
                onClick={() => setTimePickerCategoryId(null)}
                aria-label="close"
              >
                <XIcon className="w-5 h-5" />
              </button>
            </div>

            <div className="grid grid-cols-3 gap-3">
              <div>
                <div className="text-xs font-semibold text-gray-600 mb-2">Hour</div>
                <div className="h-40 overflow-auto border rounded-xl">
                  {Array.from({ length: 12 }, (_, h) => String(h + 1).padStart(2, '0')).map((hh) => (
                    <button
                      key={hh}
                      type="button"
                      onClick={() => setTimePickerHour(hh)}
                      className={`w-full text-left px-4 py-3 border-b last:border-b-0 ${hh === timePickerHour ? 'bg-blue-600 text-white' : 'bg-white text-gray-900'}`}
                    >
                      {hh}
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <div className="text-xs font-semibold text-gray-600 mb-2">Minute</div>
                <div className="h-40 overflow-auto border rounded-xl">
                  {Array.from({ length: 60 }, (_, m) => String(m).padStart(2, '0')).map((mm) => (
                    <button
                      key={mm}
                      type="button"
                      onClick={() => setTimePickerMinute(mm)}
                      className={`w-full text-left px-4 py-3 border-b last:border-b-0 ${mm === timePickerMinute ? 'bg-blue-600 text-white' : 'bg-white text-gray-900'}`}
                    >
                      {mm}
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <div className="text-xs font-semibold text-gray-600 mb-2">AM/PM</div>
                <div className="h-40 overflow-auto border rounded-xl">
                  {['AM', 'PM'].map((ap) => (
                    <button
                      key={ap}
                      type="button"
                      onClick={() => setTimePickerAmPm(ap)}
                      className={`w-full text-left px-4 py-3 border-b last:border-b-0 ${ap === timePickerAmPm ? 'bg-blue-600 text-white' : 'bg-white text-gray-900'}`}
                    >
                      {ap}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="mt-4 flex justify-end gap-2">
              <button
                type="button"
                className="bg-gray-100 hover:bg-gray-200 text-gray-800 font-semibold px-4 py-2 rounded-lg"
                onClick={() => setTimePickerCategoryId(null)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="bg-blue-600 hover:bg-blue-700 text-white font-bold px-4 py-2 rounded-lg"
                onClick={() => {
                  const hour12 = Number(timePickerHour);
                  const minute = String(timePickerMinute).padStart(2, '0');
                  let hour24 = ((hour12 % 12) + (timePickerAmPm === 'PM' ? 12 : 0));
                  if (!Number.isFinite(hour24)) hour24 = 0;
                  const time = `${String(hour24).padStart(2, '0')}:${minute}`;
                  updateCategorySchedule(timePickerCategoryId, { timeDel: time });
                  setTimePickerCategoryId(null);
                }}
              >
                Set time
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Checkout Component
const Checkout = ({ navigate, isLoggedIn, userEmail }) => {
  const { cartItems, clearCart } = useContext(CartContext);
  const [orderPlaced, setOrderPlaced] = useState(false);
  const [paymentMessage, setPaymentMessage] = useState('');
  const [isLoadingPayment, setIsLoadingPayment] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [shippingInfo, setShippingInfo] = useState({
    fullName: '',
    phone: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zip: '',
  });
  const [savedAddress, setSavedAddress] = useState(null);
  const [profileName, setProfileName] = useState('');
  const [addressMode, setAddressMode] = useState('new');
  const [addressLoading, setAddressLoading] = useState(false);
  const [addressError, setAddressError] = useState('');
  const [locationStatus, setLocationStatus] = useState('');
  const [saveAddressToProfile, setSaveAddressToProfile] = useState(false);

  const [couponCode, setCouponCode] = useState('');
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponError, setCouponError] = useState('');

  // Shipping cost state
  const [shippingCost, setShippingCost] = useState(0);
  const [deliveryConfigLoaded, setDeliveryConfigLoaded] = useState(false);

  const TERMS_TEXT = `Terms & Conditions\n\n1) Delivery lead time: We can deliver only if you place the order at least 12 hours before the selected date/time.\n2) Scheduled delivery: For tabs that require scheduling, the selected dates/time apply to all items in that tab.\n3) Availability: Delivery is subject to service availability and operational constraints.\n4) Cancellation/changes: Changes may not be possible within the 12-hour window.\n5) Pricing: Prices may change; your final charged amount is confirmed at payment.\n\nBy continuing, you agree to these terms.`;

  const pricing = useMemo(() => computePricingSummary(cartItems || []), [cartItems]);
  const couponDiscount = useMemo(() => {
    if (!appliedCoupon) return 0;
    const base = Number(pricing.total || 0);
    if (appliedCoupon.type === 'percent') {
      const raw = (base * appliedCoupon.value) / 100;
      const capped = appliedCoupon.max ? Math.min(raw, appliedCoupon.max) : raw;
      return Math.max(0, Math.round(capped * 100) / 100);
    }
    if (appliedCoupon.type === 'flat') {
      return Math.max(0, Math.min(base, appliedCoupon.value));
    }
    return 0;
  }, [appliedCoupon, pricing.total]);
  const finalTotal = Math.max(0, Number(pricing.total || 0) - Number(couponDiscount || 0) + Number(shippingCost || 0));
  const combinedDiscountTotal = Math.round((Number(pricing.discountTotal || 0) + Number(couponDiscount || 0)) * 100) / 100;
  const combinedDiscountBreakdown = useMemo(() => {
    const base = Array.isArray(pricing.discountBreakdown) ? pricing.discountBreakdown : [];
    if (!appliedCoupon || couponDiscount <= 0) return base;
    return [
      ...base,
      {
        categoryId: 'coupon',
        percent: appliedCoupon.type === 'percent' ? appliedCoupon.value : undefined,
        daysRequired: undefined,
        selectedDays: undefined,
        amount: couponDiscount,
      },
    ];
  }, [pricing.discountBreakdown, appliedCoupon, couponDiscount]);

  // Effect to load Razorpay script dynamically
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Fetch delivery config once on mount to determine shipping cost
  useEffect(() => {
    const fetchDeliveryConfig = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/delivery-config`);
        if (res.data.success) {
          setShippingCost(res.data.freeDelivery ? 0 : Number(res.data.standardCost || 0));
        }
      } catch (err) {
        // Fallback to free delivery if config fetch fails
        setShippingCost(0);
      } finally {
        setDeliveryConfigLoaded(true);
      }
    };
    fetchDeliveryConfig();
  }, []);

  useEffect(() => {
    let mounted = true;
    const token = localStorage.getItem('authToken');
    if (!isLoggedIn || !token) return;

    const loadProfile = async () => {
      try {
        setAddressLoading(true);
        setAddressError('');
        const res = await fetch(`${API_BASE_URL}/api/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json().catch(() => ({}));
        if (!mounted) return;

        if (res.ok && data.user) {
          const user = data.user;
          const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ') || user.username || user.email || '';
          setProfileName(fullName);

          // Pre-fill phone from profile if not already entered
          if (user.mobile) {
            setShippingInfo((prev) => ({ ...prev, phone: prev.phone || user.mobile || '' }));
          }

          if (user.address && Object.values(user.address).some(Boolean)) {
            const addr = user.address;
            setSavedAddress(addr);
            const isShippingEmpty = !shippingInfo.addressLine1 && !shippingInfo.city && !shippingInfo.zip;
            if (addressMode !== 'new' || isShippingEmpty) {
              if (isShippingEmpty) setAddressMode('saved');
              setShippingInfo((prev) => ({
                ...prev,
                fullName: fullName || prev.fullName,
                addressLine1: addr.line1 || '',
                addressLine2: addr.line2 || '',
                city: addr.city || '',
                state: addr.state || '',
                zip: addr.postalCode || '',
              }));
            }
          }
        } else if (res.status === 401) {
          localStorage.removeItem('authToken');
        }
      } catch (e) {
        if (mounted) setAddressError('Unable to load saved address');
      } finally {
        if (mounted) setAddressLoading(false);
      }
    };

    loadProfile();
    return () => {
      mounted = false;
    };
  }, [isLoggedIn, addressMode, shippingInfo.addressLine1, shippingInfo.city, shippingInfo.zip]);

  const applySavedAddress = () => {
    if (!savedAddress) return;
    setShippingInfo((prev) => ({
      ...prev,
      fullName: profileName || prev.fullName,
      addressLine1: savedAddress.line1 || '',
      addressLine2: savedAddress.line2 || '',
      city: savedAddress.city || '',
      state: savedAddress.state || '',
      zip: savedAddress.postalCode || '',
    }));
  };

  const handleUseCurrentLocation = () => {
    if (!navigator.geolocation) {
      setLocationStatus('Geolocation is not supported on this device.');
      return;
    }
    setLocationStatus('Detecting your location...');
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude, longitude } = pos.coords;
        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`,
            { headers: { 'Accept': 'application/json' } }
          );
          const data = await res.json();
          const addr = data.address || {};
          const line1 = [addr.house_number, addr.road].filter(Boolean).join(' ') || data.display_name || '';
          const city = addr.city || addr.town || addr.village || addr.county || '';
          const state = addr.state || '';
          const postalCode = addr.postcode || '';

          setAddressMode('new');
          setShippingInfo((prev) => ({
            ...prev,
            addressLine1: line1,
            addressLine2: '',
            city,
            state,
            zip: postalCode,
          }));
          setLocationStatus('Location found. Please verify the address.');
        } catch (e) {
          setLocationStatus('Unable to fetch address from location.');
        }
      },
      (err) => {
        setLocationStatus(err?.message || 'Location access denied.');
      },
      { enableHighAccuracy: true, timeout: 8000 }
    );
  };

  const COUPON_RULES = {
    WELCOME10: { type: 'percent', value: 10, max: 200 },
    FLAT50: { type: 'flat', value: 50 },
  };

  const applyCoupon = () => {
    const code = (couponCode || '').trim().toUpperCase();
    if (!code) {
      setCouponError('Enter a coupon code.');
      return;
    }

    const rule = COUPON_RULES[code];
    if (!rule) {
      setAppliedCoupon(null);
      setCouponError('Invalid or expired coupon.');
      return;
    }

    setAppliedCoupon({ code, ...rule });
    setCouponError('');
  };

  const clearCoupon = () => {
    setAppliedCoupon(null);
    setCouponError('');
    setCouponCode('');
  };

  const handleShippingChange = (e) => {
    const { id, value } = e.target;
    setShippingInfo((prevInfo) => ({
      ...prevInfo,
      [id]: value,
    }));
  };

  const handlePlaceOrder = async () => {
    // require login
    if (!isLoggedIn) {
      setPaymentMessage('Please login to proceed with payment');
      setTimeout(() => navigate('login'), 700);
      return;
    }
    setIsLoadingPayment(true);
    setPaymentMessage(''); // Clear previous messages

    if (!termsAccepted) {
      setPaymentMessage('Please accept Terms & Conditions to continue.');
      setIsLoadingPayment(false);
      return;
    }

    // Basic validation for shipping info
    const requiredFields = ['fullName', 'phone', 'addressLine1', 'city', 'zip'];
    const missingFields = requiredFields.filter(field => !shippingInfo[field]);
    if (missingFields.length > 0) {
      setPaymentMessage(`Please fill in all shipping details: ${missingFields.map(f => f.replace(/([A-Z])/g, ' $1').toLowerCase()).join(', ')}.`);
      setIsLoadingPayment(false);
      return;
    }

    const shippingAddressPayload = {
      line1: shippingInfo.addressLine1,
      line2: shippingInfo.addressLine2,
      city: shippingInfo.city,
      state: shippingInfo.state,
      postalCode: shippingInfo.zip,
    };

    // Validate schedule selections for check-in date/time products (per tab/category)
    const LEAD_TIME_MS = 12 * 60 * 60 * 1000;
    const now = Date.now();
    const groupedByCategory = (cartItems || []).reduce((acc, item) => {
      const key = item.categoryId || item.category || 'General';
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});

    const scheduleByCategory = {};
    const scheduleProblems = [];
    Object.keys(groupedByCategory).forEach((categoryId) => {
      const items = groupedByCategory[categoryId] || [];
      const needs = items.some((i) => !!i.checkinDT);
      if (!needs) return;

      const ref = items.find((i) => !!i.checkinDT) || {};
      const scheduleMode = ref.scheduleMode || 'week';
      const scheduleCountMode = ref.scheduleCountMode || 'single';
      const dateDels = Array.isArray(ref.dateDels) ? ref.dateDels : (ref.dateDel ? [ref.dateDel] : []);
      const timeDel = ref.timeDel || '';

      scheduleByCategory[categoryId] = { scheduleMode, scheduleCountMode, dateDels, timeDel };

      if (!timeDel || dateDels.length === 0) {
        scheduleProblems.push(categoryId);
        return;
      }

      const invalidLead = dateDels.some((d) => {
        const dt = new Date(`${d}T${timeDel}:00`);
        if (Number.isNaN(dt.getTime())) return true;
        return dt.getTime() < now + LEAD_TIME_MS;
      });
      if (invalidLead) scheduleProblems.push(categoryId);
    });

    if (scheduleProblems.length > 0) {
      const cats = scheduleProblems.slice(0, 4).join(', ');
      setPaymentMessage(
        `Please select a valid date/time (12h lead time) for: ${cats}${scheduleProblems.length > 4 ? '…' : ''}`
      );
      setIsLoadingPayment(false);
      return;
    }

    if (saveAddressToProfile && isLoggedIn) {
      try {
        const token = localStorage.getItem('authToken');
        if (token) {
          await fetch(`${API_BASE_URL}/api/auth/me`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ address: shippingAddressPayload }),
          });
        }
      } catch (e) {
        // ignore save failures
      }
    }

    try {
      // 1. Fetch Razorpay key from your backend (GET request)
      const { data: { key } } = await axios.get(`${API_BASE_URL}/api/v1/getKey`, {withCredentials: true});

      const amountToSend = Math.round(finalTotal * 100); // Amount in paise

      // 2. Process payment and create order on your backend (POST request)
      const { data: { order } } = await axios.post(`${API_BASE_URL}/api/v1/payment/process`, {
        amount: amountToSend,
      }, { withCredentials: true });

      const options = {
        key, // Use the actual key fetched from backend
        amount: order.amount, // Amount from the created order
        currency: order.currency,
        name: "techbegin.in",
        description: "Test Transaction",
        order_id: order.id, // Order ID from the backend
        // callback_url: `${API_BASE_URL}/api/v1/paymentVerification`, // This URL will be hit by Razorpay after payment
        handler: async function (response) {
          // This function is called after successful payment
          // You should send this response to your backend for verification
          try {
            const verificationResponse = await axios.post(`${API_BASE_URL}/api/v1/payment/verify`,
              {
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
                items: cartItems.map(i => {
                  const categoryKey = i.categoryId || i.category || '';
                  const sched = scheduleByCategory[categoryKey] || {};
                  const dateDels = Array.isArray(sched.dateDels) ? sched.dateDels : [];
                  return ({
                  productId: i.id,
                  name: i.name,
                  price: Math.round(i.price*100),
                  quantity: i.quantity,
                  image: i.image || '',
                  categoryId: i.categoryId || i.category || '',
                  checkinDT: !!i.checkinDT,
                  scheduleMode: i.checkinDT ? (sched.scheduleMode || i.scheduleMode || 'week') : undefined,
                  scheduleCountMode: i.checkinDT ? (sched.scheduleCountMode || i.scheduleCountMode || 'single') : undefined,
                  dateDel: i.checkinDT ? ((dateDels[0] || i.dateDel || '') ) : undefined,
                  dateDels: i.checkinDT ? (dateDels.length > 0 ? dateDels : (Array.isArray(i.dateDels) ? i.dateDels : (i.dateDel ? [i.dateDel] : []))) : undefined,
                  timeDel: i.checkinDT ? (sched.timeDel || i.timeDel || '') : undefined,
                });
                }),
                subtotalAmount: Math.round((pricing.subtotal || 0) * 100),
                totalAmount: amountToSend,
                discountAmount: Math.round((combinedDiscountTotal || 0) * 100),
                discountBreakdown: (combinedDiscountBreakdown || []).map((b) => ({
                  ...b,
                  amount: Math.round((b.amount || 0) * 100),
                })),
                userEmail: userEmail || null,
                customerName: shippingInfo.fullName,
                customerPhone: shippingInfo.phone,
                shippingAddress: shippingAddressPayload,
                shippingCost: Math.round((shippingCost || 0) * 100),
              },
              { withCredentials: true }
            );

            if (verificationResponse.data.success) {
              const createdOrder = verificationResponse.data.order;
              setPaymentMessage('Payment Successful! Redirecting to order details...');
              setOrderPlaced(true);
              clearCart();
              // Publish order success event for notifications
              publish('order:success', createdOrder);
              // navigate to order details page
              setTimeout(() => navigate('order', createdOrder._id), 700);
            } else {
              setPaymentMessage('Payment successful but order verification failed. Please contact support.');
            }
          } catch (error) {
            console.error('Error verifying payment:', error);
            setPaymentMessage('An error occurred during payment verification. Please contact support.');
          } finally {
            setIsLoadingPayment(false);
          }
        },
        prefill: {
          name: shippingInfo.fullName,
          email: userEmail || "customer@example.com",
          contact: shippingInfo.phone || "9999999999"
        },
        notes: {
          addressLine1: shippingInfo.addressLine1,
          addressLine2: shippingInfo.addressLine2,
          city: shippingInfo.city,
          state: shippingInfo.state,
          zip: shippingInfo.zip
        },
        theme: {
          color: "#3399CC"
        }
        ,
        modal: {
          ondismiss: function() {
            // User closed the payment dialog without completing payment
            try {
              setIsLoadingPayment(false);
              setPaymentMessage('Payment was not completed.');
            } catch (e) {
              // noop
            }
          }
        }
      };

      const rzp1 = new window.Razorpay(options);
      rzp1.on('payment.failed', function (response) {
        // Handle payment failure here
        console.error('Payment failed:', response.error);
        setPaymentMessage(`Payment Failed: ${response.error.description || 'Please try again.'}`);
        setIsLoadingPayment(false);
      });
      rzp1.open(); // Open the Razorpay payment dialog

    } catch (error) {
      console.error('Error initiating payment:', error);
      // More user-friendly error message based on the error type
      if (error.response && error.response.status === 400) {
        setPaymentMessage(`Payment initiation failed: ${error.response.data.message || 'Invalid request.'}`);
      } else {
        setPaymentMessage('Failed to initiate payment. Please try again later.');
      }
      setIsLoadingPayment(false);
    }
  };

  if (cartItems.length === 0 && !orderPlaced) {
    return (
      <div className="container mx-auto p-8 text-center text-gray-600 text-xl bg-white rounded-xl shadow-lg mt-8">
        <p className="mb-4">Your cart is empty. Please add items to proceed to checkout.</p>
        <button
          onClick={() => navigate('products')}
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-5 rounded-full shadow-md hover:shadow-lg transition duration-300"
        >
          Start Shopping
        </button>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4 md:p-8">
      <h2 className="text-4xl font-bold text-center text-gray-800 mb-8 mt-4">Checkout</h2>

      {orderPlaced ? (
        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 text-center">
          <h3 className="text-3xl font-bold text-green-600 mb-4">Order Placed Successfully!</h3>
          <p className="text-gray-700 text-lg mb-6">{paymentMessage}</p>
          <button
            onClick={() => navigate('products')}
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-full shadow-md hover:shadow-lg transition duration-300"
          >
            Continue Shopping
          </button>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Shipping Information Form */}
            <div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Shipping Information</h3>
              {isLoggedIn && (
                <div className="mb-4 p-4 border border-gray-200 rounded-lg bg-gray-50">
                  <div className="flex items-center justify-between">
                    <h4 className="text-sm font-semibold text-gray-700">Saved Address</h4>
                    {addressLoading && <span className="text-xs text-gray-500">Loading...</span>}
                  </div>
                  {addressError && <div className="text-xs text-red-600 mt-1">{addressError}</div>}
                  {!addressLoading && savedAddress ? (
                    <div className="mt-2 text-sm text-gray-600 space-y-1">
                      <div>{savedAddress.line1}</div>
                      {savedAddress.line2 && <div>{savedAddress.line2}</div>}
                      <div>{[savedAddress.city, savedAddress.state].filter(Boolean).join(', ')}</div>
                      <div>{savedAddress.postalCode}</div>
                    </div>
                  ) : (
                    !addressLoading && <div className="mt-2 text-xs text-gray-500">No saved address found.</div>
                  )}

                  {savedAddress && (
                    <div className="mt-3 flex items-center gap-4 text-sm">
                      <label className="flex items-center gap-2">
                        <input
                          type="radio"
                          name="addressMode"
                          value="saved"
                          checked={addressMode === 'saved'}
                          onChange={() => {
                            setAddressMode('saved');
                            applySavedAddress();
                            setSaveAddressToProfile(false);
                          }}
                        />
                        Use saved address
                      </label>
                      <label className="flex items-center gap-2">
                        <input
                          type="radio"
                          name="addressMode"
                          value="new"
                          checked={addressMode === 'new'}
                          onChange={() => setAddressMode('new')}
                        />
                        Use new address
                      </label>
                    </div>
                  )}
                </div>
              )}

              <div className="mb-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                <button
                  type="button"
                  onClick={handleUseCurrentLocation}
                  className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-4 py-2 rounded-lg"
                >
                  Use my current location
                </button>
                {locationStatus && <span className="text-xs text-gray-600">{locationStatus}</span>}
              </div>

              <form className="space-y-4">
                <div>
                  <label htmlFor="fullName" className="block text-gray-700 text-sm font-bold mb-2">
                    Full Name
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    className="shadow appearance-none border rounded-lg w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={shippingInfo.fullName}
                    onChange={handleShippingChange}
                    required
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-gray-700 text-sm font-bold mb-2">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    placeholder="10-digit mobile number"
                    className="shadow appearance-none border rounded-lg w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={shippingInfo.phone}
                    onChange={handleShippingChange}
                    maxLength={10}
                    required
                  />
                </div>
                <div>
                  <label htmlFor="addressLine1" className="block text-gray-700 text-sm font-bold mb-2">
                    Address Line 1
                  </label>
                  <input
                    type="text"
                    id="addressLine1"
                    className="shadow appearance-none border rounded-lg w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={shippingInfo.addressLine1}
                    onChange={handleShippingChange}
                    disabled={addressMode === 'saved'}
                    required
                  />
                </div>
                <div>
                  <label htmlFor="addressLine2" className="block text-gray-700 text-sm font-bold mb-2">
                    Address Line 2 (optional)
                  </label>
                  <input
                    type="text"
                    id="addressLine2"
                    className="shadow appearance-none border rounded-lg w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={shippingInfo.addressLine2}
                    onChange={handleShippingChange}
                    disabled={addressMode === 'saved'}
                  />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  <div>
                    <label htmlFor="city" className="block text-gray-700 text-sm font-bold mb-2">
                      City
                    </label>
                    <input
                      type="text"
                      id="city"
                      className="shadow appearance-none border rounded-lg w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-400"
                      value={shippingInfo.city}
                      onChange={handleShippingChange}
                      disabled={addressMode === 'saved'}
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="state" className="block text-gray-700 text-sm font-bold mb-2">
                      State
                    </label>
                    <input
                      type="text"
                      id="state"
                      className="shadow appearance-none border rounded-lg w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-400"
                      value={shippingInfo.state}
                      onChange={handleShippingChange}
                      disabled={addressMode === 'saved'}
                    />
                  </div>
                  <div>
                    <label htmlFor="zip" className="block text-gray-700 text-sm font-bold mb-2">
                      Pin Code
                    </label>
                    <input
                      type="text"
                      id="zip"
                      className="shadow appearance-none border rounded-lg w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-400"
                      value={shippingInfo.zip}
                      onChange={handleShippingChange}
                      disabled={addressMode === 'saved'}
                      required
                    />
                  </div>
                </div>
              </form>

              {isLoggedIn && addressMode === 'new' && (
                <label className="mt-3 flex items-start gap-3 text-sm text-gray-700">
                  <input
                    type="checkbox"
                    className="mt-1"
                    checked={saveAddressToProfile}
                    onChange={(e) => setSaveAddressToProfile(e.target.checked)}
                  />
                  Save this address to my profile
                </label>
              )}
            </div>

            {/* Order Summary */}
            <div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Order Summary</h3>
              <div className="border border-gray-200 rounded-lg p-4 space-y-3">
                {cartItems.map((item) => (
                  <div key={item.id} className="flex justify-between items-center">
                    <span className="text-gray-700">
                      {item.name} (x{item.quantity})
                      {(pricing.categoryDays[item.categoryId || item.category || 'General'] || 1) > 1 && (
                        <span className="text-gray-500"> × {pricing.categoryDays[item.categoryId || item.category || 'General']} days</span>
                      )}
                    </span>
                    <span className="font-medium">₹{(
                      (Number(item.price || 0) * Number(item.quantity || 0)) *
                      ((pricing.categoryDays[item.categoryId || item.category || 'General'] || 1))
                    ).toFixed(2)}</span>
                  </div>
                ))}
                {(Number(pricing.discountTotal || 0) > 0 || Number(couponDiscount || 0) > 0) && (
                  <>
                    <div className="border-t border-gray-200 pt-3 flex justify-between items-center text-sm">
                      <span className="text-gray-700">Subtotal</span>
                      <span className="font-medium">₹{Number(pricing.subtotal || 0).toFixed(2)}</span>
                    </div>
                    {Number(pricing.discountTotal || 0) > 0 && (
                      <div className="flex justify-between items-center text-sm">
                        <span className="text-green-700 font-semibold">Multi-day discount</span>
                        <span className="text-green-700 font-semibold">-₹{Number(pricing.discountTotal || 0).toFixed(2)}</span>
                      </div>
                    )}
                    {Number(couponDiscount || 0) > 0 && (
                      <div className="flex justify-between items-center text-sm">
                        <span className="text-green-700 font-semibold">Coupon ({appliedCoupon?.code})</span>
                        <span className="text-green-700 font-semibold">-₹{Number(couponDiscount || 0).toFixed(2)}</span>
                      </div>
                    )}
                    <div className="flex justify-between items-center text-sm">
                      <span className="text-green-700">You saved</span>
                      <span className="text-green-700 font-semibold">₹{(Number(pricing.saved || 0) + Number(couponDiscount || 0)).toFixed(2)}</span>
                    </div>
                  </>
                )}

                {/* Shipping Cost */}
                <div className="border-t border-gray-200 pt-3 space-y-1">
                  <div className="flex justify-between items-center text-sm">
                    <span className="text-gray-700">Delivery Charges</span>
                    {!deliveryConfigLoaded ? (
                      <span className="text-gray-400 text-sm">---</span>
                    ) : shippingCost > 0 ? (
                      <span className="font-medium">₹{Number(shippingCost).toFixed(2)}</span>
                    ) : (
                      <span className="text-green-700 font-semibold">FREE</span>
                    )}
                  </div>
                </div>

                <div className="border-t border-gray-200 pt-3 flex justify-between items-center font-bold text-lg">
                  <span>Total:</span>
                  <span className="text-blue-700">₹{finalTotal.toFixed(2)}</span>
                </div>
              </div>

              <div className="mt-4 p-4 border border-gray-200 rounded-lg bg-gray-50 space-y-3">
                <div className="flex items-center justify-between">
                  <label htmlFor="coupon" className="text-sm font-semibold text-gray-700">Coupon (optional)</label>
                  {appliedCoupon && (
                    <button
                      type="button"
                      onClick={clearCoupon}
                      className="text-xs text-red-600 hover:text-red-700"
                    >
                      Remove
                    </button>
                  )}
                </div>
                <div className="flex gap-2">
                  <input
                    type="text"
                    id="coupon"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value)}
                    placeholder="Enter coupon code"
                    className="flex-1 border rounded-lg px-3 py-2 text-sm"
                    disabled={!!appliedCoupon}
                  />
                  <button
                    type="button"
                    onClick={applyCoupon}
                    className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-4 rounded-lg"
                    disabled={!!appliedCoupon}
                  >
                    Apply
                  </button>
                </div>
                {couponError && <div className="text-xs text-red-600">{couponError}</div>}
                {appliedCoupon && (
                  <div className="text-xs text-green-700">Applied {appliedCoupon.code}</div>
                )}
              </div>

              <div className="mt-4 p-4 border border-gray-200 rounded-lg bg-gray-50">
                <label className="flex items-start gap-3 text-sm text-gray-800">
                  <input
                    type="checkbox"
                    className="mt-1"
                    checked={termsAccepted}
                    onChange={(e) => setTermsAccepted(e.target.checked)}
                  />
                  <span>
                    I agree to the{' '}
                    <button
                      type="button"
                      className="text-blue-700 underline font-semibold"
                      onClick={() => setShowTerms(true)}
                    >
                      Terms & Conditions
                    </button>
                    .
                  </span>
                </label>
                {!termsAccepted && (
                  <p className="mt-2 text-xs text-gray-600">You must accept terms before paying.</p>
                )}
              </div>

              {paymentMessage && (
                <MessageModal
                  message={paymentMessage}
                  type={paymentMessage.includes('Successful') ? 'success' : 'error'}
                  onClose={() => setPaymentMessage('')}
                />
              )}

              <button
                onClick={handlePlaceOrder}
                className={`w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-full shadow-lg hover:shadow-xl transition duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-75 text-lg mt-6
                  ${(isLoadingPayment || !termsAccepted) ? 'opacity-70 cursor-not-allowed' : ''}`}
                disabled={isLoadingPayment || !termsAccepted}
              >
                {isLoadingPayment ? 'Processing Payment...' : 'Pay Now'}
              </button>
              {/* mobile-only spacer so the fixed BottomNav doesn't overlap the Pay Now button */}
              <div className="h-24 md:hidden" />
            </div>
          </div>
        </div>
      )}

      {showTerms && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-[110]">
          <div className="relative bg-white rounded-xl shadow-xl w-full max-w-lg mx-4 p-5">
            <button
              onClick={() => setShowTerms(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
              aria-label="close"
            >
              <XIcon className="w-5 h-5" />
            </button>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Terms & Conditions</h3>
            <div className="max-h-[60vh] overflow-auto text-sm text-gray-800 whitespace-pre-line border border-gray-200 rounded-lg p-3">
              {TERMS_TEXT}
            </div>
            <div className="mt-4 flex justify-end gap-2">
              <button
                type="button"
                className="bg-gray-100 hover:bg-gray-200 text-gray-800 font-semibold px-4 py-2 rounded-lg"
                onClick={() => setShowTerms(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="bg-blue-600 hover:bg-blue-700 text-white font-bold px-4 py-2 rounded-lg"
                onClick={() => { setTermsAccepted(true); setShowTerms(false); }}
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


// Main App Component
const AppContent = () => {
  const [currentPage, setCurrentPage] = useState('products'); // Default page
  const [currentProductId, setCurrentProductId] = useState(null); // For product detail page
  const [searchQuery, setSearchQuery] = useState(''); // Global search query
  const [foodMode, setFoodMode] = useState(false); // Toggle for 3 Amigos food tab
  const { cartItems } = useContext(CartContext); // Get cart items for count
  const [products, setProducts] = useState([]);
  const [productsLoading, setProductsLoading] = useState(true);
  const [productsError, setProductsError] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("authToken")
  );
  const [userEmail, setUserEmail] = useState(
    localStorage.getItem("userEmail") || ''
  );
  const [userName, setUserName] = useState(localStorage.getItem('userName') || '');
  const [resetToken, setResetToken] = useState(null);
  
  // Get notification count from context
  const { unreadCount: notificationCount } = useNotifications();

  const PRODUCTS_CACHE_KEY = 'tb_products_cache_v1';

  useEffect(() => {
    let ignore = false;
    const warm = async () => {
      try {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 2000);
        await fetch(`${API_BASE_URL}/api/health`, {
          method: 'GET',
          cache: 'no-store',
          signal: controller.signal,
        });
        clearTimeout(timeout);
      } catch (e) {
        // ignore warmup errors
      }
    };
    if (!ignore) warm();
    return () => {
      ignore = true;
    };
  }, []);
  

  // Listen for auth events so other components can update App state
  useEffect(() => {
    const unsubLogin = subscribe('auth:login', (data) => {
      setIsLoggedIn(true);
      if (data?.email) {
        setUserEmail(data.email);
        localStorage.setItem('userEmail', data.email);
      }
      if (data?.username) {
        setUserName(data.username);
        localStorage.setItem('userName', data.username);
      }
    });
    const unsubLogout = subscribe('auth:logout', () => {
      setIsLoggedIn(false);
      setUserEmail('');
      setUserName('');
      localStorage.removeItem('authToken');
      localStorage.removeItem('userEmail');
      localStorage.removeItem('userName');
    });
    return () => { try { unsubLogin(); unsubLogout(); } catch (e) {} };
  }, []);

  // If user came directly to /reset-password/<token>, capture token and switch to reset page
  useEffect(() => {
    const pathname = window.location.pathname || '';
    // match /reset-password/sometoken  (capturing anything after the last slash)
    const match = pathname.match(/^\/reset-password\/(.+)$/);
    if (match && match[1]) {
      setResetToken(match[1]);
      setCurrentPage('resetPassword'); // show reset password page in your renderPage switch
    }
  }, []);

  useEffect(() => {
    let isMounted = true;

    // Hydrate from cache first to avoid long blank/loading states (esp. when backend is cold).
    let hasCache = false;
    try {
      const cachedRaw = localStorage.getItem(PRODUCTS_CACHE_KEY);
      if (cachedRaw) {
        const cached = JSON.parse(cachedRaw);
        const cachedItems = Array.isArray(cached?.products) ? cached.products : [];
        if (cachedItems.length > 0) {
          const normalizedCached = cachedItems.map(normalizeProduct);
          setProducts(normalizedCached);
          setProductsError(null);
          setProductsLoading(false);
          hasCache = true;
        }
      }
    } catch (e) {
      // ignore cache parse errors
    }

    const fetchProducts = async () => {
      try {
        if (!hasCache) setProductsLoading(true);
        const { data } = await axios.get(`${API_BASE_URL}/api/v1/products`);
        const items = Array.isArray(data?.products) ? data.products : [];
        const normalized = items.map(normalizeProduct);
        if (isMounted) {
          setProducts(normalized);
          setProductsError(null);

          try {
            localStorage.setItem(PRODUCTS_CACHE_KEY, JSON.stringify({ at: Date.now(), products: normalized }));
          } catch (e) {
            // ignore quota/write errors
          }
        }
      } catch (error) {
        if (isMounted) {
          // If we already have cached products, keep showing them.
          if (!hasCache) setProducts([]);
          setProductsError('Failed to load products');
        }
      } finally {
        if (isMounted) setProductsLoading(false);
      }
    };

    fetchProducts();
    return () => {
      isMounted = false;
    };
  }, []);

  

  // Function to navigate between pages
  const navigate = (page, productId = null) => {

    if (window.location.pathname === "/track-order") {
      window.history.pushState({}, "", "/");
    }
    setCurrentPage(page);
    setCurrentProductId(productId);
    // Clear search query when navigating to a non-product list page
    if (page !== 'products') {
      setSearchQuery('');
    }

    // optionally update URL when navigating to resetPassword so the link is shareable:
    if (page !== 'resetPassword') {
      // reset any reset-password URL if we navigate away
      if (window.location.pathname.startsWith('/reset-password/')) {
        window.history.replaceState({}, '', '/');
      }
    }
  };

  const handleLogin = (email, usernameArg) => {
    const username = usernameArg || localStorage.getItem('userName') || '';
    setIsLoggedIn(true);
    setUserEmail(email);
    setUserName(username);
    localStorage.setItem("userEmail", email);
    if (username) localStorage.setItem('userName', username);
  };


  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userEmail");

    setIsLoggedIn(false);
    setUserEmail('');
    setUserName('');

    try { publish('auth:logout'); } catch (e) { }

    navigate('products');
  };


  // Render the appropriate component based on currentPage state
  const renderPage = () => {
    switch (currentPage) {
      case 'products':
        return (
          <Home
            navigate={navigate}
            searchQuery={searchQuery}
            products={products}
            productsLoading={productsLoading}
            productsError={productsError}
            foodMode={foodMode}
          />
        );

      case 'productDetail':
        return <ProductDetail navigate={navigate} productId={currentProductId} products={products} />;

      case 'cart':
        return <Cart navigate={navigate} />;

      case 'trackOrder':
        return <TrackOrder />;

      case 'profile':
        return <ProfileSettings navigate={navigate} isLoggedIn={isLoggedIn} />;

      case 'notifications':
        return <Notifications navigate={navigate} />;

      case 'checkout':
        return <Checkout navigate={navigate} isLoggedIn={isLoggedIn} userEmail={userEmail} />;

      case 'order':
        return <OrderDetails navigate={navigate} orderId={currentProductId} />;

      case 'login':
        return <Login navigate={navigate} onLogin={handleLogin} />;


      case 'register':
        return <Register navigate={navigate} onLogin={handleLogin} />;

      case 'verifyOtp':
        return <VerifyOtp navigate={navigate} onLogin={handleLogin} />;

      case 'resetPassword':
        return <ResetPassword navigate={navigate} token={resetToken} />;

      default:
          return (
            <Home
              navigate={navigate}
              searchQuery={searchQuery}
              products={products}
              productsLoading={productsLoading}
              productsError={productsError}
              foodMode={foodMode}
            />
          );
    }
  };


  return (
    <UserOrdersProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col bg-gray-50 font-sans antialiased with-bottom-nav">

          <Header
            navigate={navigate}
            cartItemCount={cartItems.length}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            isLoggedIn={isLoggedIn}
            userEmail={userEmail}
            userName={userName}
            handleLogout={handleLogout}
            notificationCount={notificationCount}
            currentPage={currentPage}
            products={products}
            foodMode={foodMode}
            setFoodMode={setFoodMode}
          />

          <main className="flex-grow">
            <Routes>
              {/* Existing app stays as-is */}
              <Route path="/*" element={renderPage()} />

              
            </Routes>
          </main>

          <BottomNav navigate={navigate} currentPage={currentPage} cartItemCount={cartItems.length} />
          <FeedbackBubble isLoggedIn={isLoggedIn} userEmail={userEmail} />
          {currentPage !== 'cart' && currentPage !== 'trackOrder' && currentPage !== 'profile' && currentPage !== 'checkout' && currentPage !== 'login' && <Footer />}
        </div>
      </BrowserRouter>
    </UserOrdersProvider>
  );

};

// Main App wrapper with NotificationProvider
const App = () => {
  return (
    <NotificationProvider>
      <AppContent />
    </NotificationProvider>
  );
};



export default App;

